import React from 'react';
import { Box } from '@mui/material';
import { SessionWatermarking } from '../services/contractors';

type Props = {
  watermarking: SessionWatermarking;
  identity: string;
  startedAt: number | null;
};

const TILE = 320;

function stamp(watermarking: Props['watermarking'], identity: string, startedAt: number | null) {
  const parts: string[] = [];
  if (watermarking.showContractorIdentity && identity) parts.push(identity);
  if (watermarking.showSessionDuration) {
    parts.push(new Date(startedAt ?? Date.now()).toLocaleString());
  }
  return parts.join('  ');
}

const SessionWatermark: React.FC<Props> = ({ watermarking, identity, startedAt }) => {
  if (!watermarking.enabled) return null;

  const text = stamp(watermarking, identity, startedAt);
  if (!text) return null;

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${TILE}" height="${TILE}">
    <text x="50%" y="50%" fill="rgba(255,255,255,0.10)" font-family="monospace" font-size="13"
      text-anchor="middle" transform="rotate(-30 ${TILE / 2} ${TILE / 2})">${text.replace(
        /[<>&"]/g,
        (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c] as string)
      )}</text>
  </svg>`;

  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 5,
        pointerEvents: 'none',
        backgroundImage: `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`,
        backgroundRepeat: 'repeat',
      }}
    />
  );
};

export default SessionWatermark;
